import { useQuery } from '@tanstack/react-query';
import { getDeliveryRates, type DeliveryRateOption } from '@/services/deliveryRates';
import { isValidStateCity } from '@/lib/nigeriaLocations';

export function useDeliveryRates(params: {
  sellerId: string;
  destinationState: string;
  destinationCity: string;
  destinationAddress?: string;
  items?: Array<{ quantity: number; price: number; title: string }>;
  weight?: number;
}) {
  const enabled =
    isValidStateCity(params.destinationState, params.destinationCity);

  const itemsKey = (params.items || [])
    .map((i) => `${i.title}:${i.quantity}:${i.price}`)
    .join('|');

  return useQuery<{ rates: DeliveryRateOption[]; source?: string }>(
    {
      queryKey: [
        'deliveryRates',
        params.sellerId,
        params.destinationState,
        params.destinationCity,
        params.destinationAddress || '',
        itemsKey,
        params.weight || 1,
      ],
      enabled,
      queryFn: () => getDeliveryRates(params),
      staleTime: 5 * 60 * 1000, // 5 minutes — prevent constant refetches that cause rates to disappear
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 2,
      placeholderData: (previousData: any) => previousData, // Keep previous rates visible while refetching
    }
  );
}
